// extracted by mini-css-extract-plugin
export default {"container":"EntityType_container__8wBru","entityTypeImage":"EntityType_entityTypeImage__NG4JU","displayLabel":"EntityType_displayLabel__6BgX0"};